define('v3/Pages/WayOfWork/Services/WayOfWork.Service',[
	'v3/Pages/WayOfWork/Services/WayOfWork.Backend'
], function (wayOfWorkBackend) {
	return {
		getAvailableSubjectCategories: function () {
			return wayOfWorkBackend.getAvailableSubjectCategories();
		},
		getStage: function (subjectCategory) {
			return wayOfWorkBackend.getStage(subjectCategory);
		},
		getProgress: function (subjectCategory) {
			return wayOfWorkBackend.getProgress(subjectCategory);
		},
		getBoundaries: function (subjectCategory) {
			return wayOfWorkBackend.getBoundaries(subjectCategory);
		}
	};
});
